import _ from 'lodash';

import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import handleSignIn from '../../../services/apollo/func/handle/handleSignIn';
import fetchMe from '../../../services/apollo/func/fetch/fetchMe';

export const getSchema = () => {
  const schema = yup.object().shape({
    email: yup.string().trim().required(''),
    password: yup.string().trim().required(''),
  });
  return schema;
};

export const getForm = schema => useForm({
  mode: 'onChange',
  defaultValues: {
    email: '',
    password: '',
  },
  resolver: yupResolver(schema),
});
export const handleLogin = async (username, password) => {
  try {
    const params = {
      email: username,
      password,
    };
    // BpLnfgDsc2WD
    const result = await handleSignIn({ params });
    if (!_.isEmpty(result)) {
      return {
        me: result.me,
        accessToken: result.accessToken,
      };
    }
    return {
      me: {},
    };
  } catch (err) {
    return {
      me: {},
    };
  }
};

export default handleLogin;
